<template>
  <div class="tobe_reviewed">
    <head-top head-title="跑楼审核" go-back="true"></head-top>
    <div class="reviewed">
      <div class="search_part">
        <div class="box_input">
          <img src="./images/btn_search@2x.png" alt="">
          <input type="text" @keyup.enter="searchVillage"  @input="searchVillage" v-model="keyword" placeholder="搜索小区名称">
        </div>
      </div>
      <div class="tobe_list">
        <div class="list_box" v-for="(item, index) in data" :key="index">
          <div class="box_single">
            <div class="basics">
              <h3>{{item.areas_name}}</h3>
              <div class="bas_li"><span>姓名：</span>{{item.real_name}}</div>
              <div class="bas_li"><span>手机号：</span>{{item.phone}}</div>
              <div class="bas_li">
                <span>状态：</span>
                <span class="slove" v-if="item.status===0">未处理</span>
                <span class="no-slove" v-if="item.status===1">已通过</span>
                <span class="slove-ing" v-if="item.status===2">未通过</span>
              </div>
              <div class="bas_time" @click="openPicker([index])">
                <span>结束时间：</span>
                <input type="text" v-model="item.end_time" placeholder="请选择结束时间" readonly>
                <img src="../home/images/fanhui1@2x.png" alt="">
              </div>
            </div>
            <div class="btn_part">
              <div class="btn" @click="refuseRun(item.id)">拒绝</div>
              <div class="btn" @click="adoptRun(item.id, item.end_time)">通过</div>
            </div>
          </div>
        </div>
      </div>
      <!--时间弹窗-->
      <mt-datetime-picker
        ref="picker"
        type="date"
        :startDate='startTime'
        yearFormat="{value}年"
        monthFormat="{value}月"
        dateFormat="{value}日"
        v-model="pickerValue"
        @confirm="handleConfirm">
      </mt-datetime-picker>
      <!--结束时间的弹窗-->
    </div>
    <div class="default1" v-show="noResult">
      <p>抱歉！暂无数据</p>
    </div>
  </div>
</template>

<script>
  import headTop from '../../components/header/Header'
  import {auditAreas, authAreaList} from '../../api/my'
  import {Indicator, Toast} from 'mint-ui'

  export default {
    name: 'authAreas',
    data () {
      return {
        data: [],
        keyword: '',
        pickerValue: '', // 时间选择v-model的值
        // startTime: '请选择开始时间',
        sTime: '',
        startTime: '',
        type: 0,
        noResult: false,
        indexArr: []
      }
    },
    created() {
      this.startTime = new Date()
      this._authAreaList()
    },
    methods: {
      searchVillage() {
        Indicator.open({
          text: '..搜索中..',
          spinnerType: 'fading-circle'
        })
        authAreaList(this.keyword).then(res => {
          if (res.code === 200) {
            Indicator.close()
            this.data = res.data
            if (this.data.length === 0) {
              this.noResult = true
            } else {
              this.noResult = false
            }
            // console.log(this.data)
          }
        })
      },
      // 列表数据
      _authAreaList() {
        Indicator.open({
          text: '..加载中..',
          spinnerType: 'fading-circle'
        })
        authAreaList().then(res => {
          console.log(res)
          if (res.code === 200) {
            Indicator.close()
            this.data = res.data
            if (this.data.length === 0) {
              this.noResult = true
            } else {
              this.noResult = false
            }
            // console.log(this.data)
          }
        })
      },
      // 开始时间
      openPicker (index) {
        this.indexArr = index
        this.$refs.picker.open()
      },
      handleConfirm (e) {
        const [one] = this.indexArr
        this.data.map((item, key) => {
          if (key === one) {
            item.end_time = this.formatDate(e)
          }
          return item
        })
      },
      // 时间转换
      formatDate(secs) {
        var t = new Date(secs)
        var year = t.getFullYear()
        var month = t.getMonth() + 1
        if (month < 10) { month = '0' + month }
        var date = t.getDate()
        if (date < 10) { date = '0' + date }
        var hour = t.getHours()
        if (hour < 10) { hour = '0' + hour }
        var minute = t.getMinutes()
        if (minute < 10) { minute = '0' + minute }
        var second = t.getSeconds()
        if (second < 10) { second = '0' + second }
        return year + '-' + month + '-' + date
      },
      // 拒绝
      refuseRun (id) {
        Indicator.open({
          text: '..提交中..',
          spinnerType: 'fading-circle'
        })
        auditAreas(id, 2).then(res => {
          // console.log(res)
          Indicator.close()
          if (res.code === 200) {
            Toast({
              message: res.data,
              position: 'middle',
              duration: 2000
            })
            this._authAreaList()
          }
          if (res.code === 400) {
            Indicator.close()
            Toast({
              message: res.error,
              position: 'middle',
              duration: 2000
            })
            return
          }
        })
      },
      // 通过
      adoptRun (id, time) {
        Indicator.open({
          text: '..提交中..',
          spinnerType: 'fading-circle'
        })
        auditAreas(id, 1, time).then(res => {
          // console.log(res)
          if (res.code === 200) {
            Indicator.close()
            Toast({
              message: res.data,
              position: 'middle',
              duration: 2000
            })
            this._authAreaList()
          }
          if (res.code === 400) {
            Indicator.close()
            Toast({
              message: res.error,
              position: 'middle',
              duration: 2000
            })
            return
          }
        })
      }
    },
    components: {
      headTop
    }
  }
</script>

<style lang="scss" scoped>
  .tobe_reviewed{
    padding-top: 60px;
    .reviewed{
      width: 100%;
      .search_part{
        padding: 10px;
        .box_input{
          display: inline-flex;
          align-items: center;
          background: white;
          border: 1px solid #0C7AD9;
          border-radius: 20px;
          /*padding: 5px;*/
          width: 100%;
          img{
            width: 20px;
            height: 20px;
            margin:0 10px;
          }
          input{
            background: white;
            border: none;
            outline: none;
            padding: 10px 0;
            font-size: 15px;
            color: #999999;
          }
        }
      }
      .tobe_list{
        //margin-top: 20px;
        .list_box{
          h3{
            font-size: 17px;
            color: #0C7AD9;
            padding: 10px;
            background: #f2f2f2;
          }
          .box_single{
            padding: 5px 10px;
            /*border-bottom: 10px solid #f2f2f2;*/
            .basics{
              border-radius: 5px;
              border: 1px solid #f2f2f2;
              box-shadow: 3px 2px 5px #f2f2f2;
              padding: 10px 10px;
              margin-top: 10px;
              .bas_li{
                font-size: 15px;
                color: #666666;
                margin-top: 10px;
                span{
                  color: #333333;
                }
                .slove {
                  color: #EE991B;
                }
                .no-slove {
                  color: #1B701C;
                }
                .slove-ing{
                  color: #F30707;
                }
              }
              .bas_time{
                font-size: 15px;
                span{
                  color: #333333;
                }
                input{
                  background: white;
                  outline: none;
                  border: none;
                  font-size: 15px;
                  padding: 10px 0;
                  color: #666666;
                }
                img{
                  width: 8px;
                  height: 15px;
                  transform: rotate(90deg);
                }
              }
            }
            .btn_part{
              display: inline-flex;
              align-items: center;
              justify-content: space-between;
              width: 100%;
              margin-top: 10px;
              .btn{
                font-size: 16px;
                color: #ffffff;
                border-radius: 10px;
                width: 45%;
                padding: 15px 0;
                text-align: center;
              }
              .btn:first-child{
                background: #dddddd;
              }
              .btn:last-child{
                background: #0C7AD9;
              }
            }
          }
        }
      }
    }
    .default1 {
      width: 100%;
      flex: 1;
      display: inline-flex;
      padding-top: 100px;
      justify-content: center;
      align-items: center;
      background: url("../../assets/default.png") no-repeat;
      background-size: 100px 100px;
      background-position: center;
      padding-bottom: 140px;
      p {
        font-size: 15px;
        color: #0b7ad9;
        margin-top: 180px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/my/authAreas.vue